import { render, staticRenderFns } from "./EditObstetric.vue?vue&type=template&id=492fda1f&scoped=true"
import script from "./EditObstetric.vue?vue&type=script&lang=js"
export * from "./EditObstetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492fda1f",
  null
  
)

export default component.exports